<div>
  @if (busy) {
    <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
  }
  <h2 mat-dialog-title class="w-100 text-center primary-color"><b>{{title}}</b></h2>
  <mat-dialog-content>
    <form [formGroup]="presetForm" class="mt-3">
      <h3 class="flex-row items-center"><span class="sequenceNo mr-3">1</span>Name your preset</h3>
      <div class="flex-row flex-wrap space-between items-start mt-3 pl-5">
          <mat-form-field class="w-100" appearance="outline">
              <mat-label>Preset Name</mat-label>
              <input matInput #namefield formControlName="presetName" required autocomplete="off">
              @if(presetForm.controls.presetName.errors?.required){<mat-error> Name is required</mat-error>}
              @if(presetForm.controls.presetName.hasError('minlength')){<mat-error>Name is not long enough. Minimum of 3 characters is required.</mat-error>}
              @if(presetForm.controls.presetName.hasError('maxlength')){<mat-error>Name is too long. Maximum of 100 characters is allowed.</mat-error>}
              @if(presetForm.controls.presetName.hasError('duplicateName')){<mat-error>Name is already in use in this moov.</mat-error>}
          </mat-form-field>
      </div>
      <div class="flex-row items-center w-100">
        <span class="sequenceNo mr-3">2</span>
        <div class="flex-row space-between items-center flex-1">
          <h3>Select mapping fields</h3>
          <mat-slide-toggle labelPosition="before" color="primary" (change)="onSortChanged($event)">Sort by step</mat-slide-toggle>
        </div>

      </div>
      <mat-selection-list class="pl-5" #selectionList formControlName="presets" (selectionChange)="onSelectionChange($event)">
        @for(ap of abstractParameters; track $index){
          <mat-list-option [value]="ap" [disabled]="ap.disabled">
            <div class="multi-column-option">
              <span class="column-item">{{ ap.label }}</span>
              <span class="column-item">Step {{ ap.moovStepSequenceNo + 1 }}</span>
              <span class="column-item">{{ ap.moovStepDescription}}</span>
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
    </form>
    
  </mat-dialog-content>
</div>
<mat-dialog-actions>
  <div class="mt-3 p-2 w-100 flex-row space-between items-center">
    <a mat-button color="primary" (click)="onCancelClick()">{{cancelButtonText}}</a>
    @if(preset){<a mat-button color="warn" (click)="onDeleteClick()">{{deleteButtonText}}</a>}
    <button mat-flat-button color="primary" [disabled]="!canSubmit" (click)="onSubmitClick()">{{submitButtonText}}</button>
  </div>
</mat-dialog-actions>